<div class="d-flex navigation-header">
    <h1 (click)="goBack()" id="panel">{{"admin.title" | translate }}</h1>
    <h1>&nbsp; > {{"admin.users.title" | translate}}</h1>
    <mat-form-field color="standart" [ngClass]="(isEnglish()) ? 'search-input-en' : 'search-input-de'">
        <mat-label>{{"admin.users.customerNumber" | translate }}</mat-label>
        <input matInput [(ngModel)]="customerNumberSearch" (keydown.enter)="search()"
                        (ngModelChange)="customerNumberSearch.length == 0 && search()">
    </mat-form-field>
    <app-search-button (click)="search()" style="margin-right: 20px;"></app-search-button>
    <button mat-flat-button color="primary" (click)="openNewUserDialog()" class="action-button">{{'admin.users.addNew' | translate}}</button>
</div>
<div class="order-table">
    <table mat-table [dataSource]="items" matSort (matSortChange)="sortData($event)" class="mat-elevation-z8">

        <ng-container matColumnDef="customerNumber">
            <th mat-header-cell *matHeaderCellDef [width]="200" mat-sort-header="customerNumber">{{"admin.users.customerNumber" | translate}}</th>
            <td mat-cell *matCellDef="let row">{{row.account.customerNumber}}</td>
        </ng-container>

        <ng-container matColumnDef="customerName">
            <th mat-header-cell *matHeaderCellDef [width]="240" mat-sort-header="customerName">{{"admin.users.customerName" | translate}}</th>
            <td mat-cell *matCellDef="let row">{{row.account.customerName}}</td>
        </ng-container>

        <ng-container matColumnDef="username">
            <th mat-header-cell *matHeaderCellDef [width]="240" mat-sort-header="username">{{"admin.users.username" | translate}}</th>
            <td mat-cell *matCellDef="let row">{{row.username}}</td>
        </ng-container>

        <ng-container matColumnDef="fullName">
            <th mat-header-cell *matHeaderCellDef [width]="240" mat-sort-header="fullName">{{"admin.users.fullName" | translate}}</th>
            <td mat-cell *matCellDef="let row">{{row.fullName}}</td>
        </ng-container>

        <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="role">{{"admin.users.role" | translate}}</th>
            <td mat-cell *matCellDef="let row">{{row.role}}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="actions-header">{{"admin.users.actions" | translate}}</th>
            <td mat-cell *matCellDef="let row" class="actions">
                <div class="d-flex">
                    <img src="assets/img/icons/edit.svg" [matTooltip]="'home.orders.tooltips.edit' | translate" matTooltipPosition="above" (click)="openEditUserDialog(row)">
                    <img src="assets/img/icons/delete2.svg" [matTooltip]="'home.orders.tooltips.delete' | translate" matTooltipPosition="above" (click)="deleteUser(row)">
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 15, 20]" showFirstLastButtons color="standart" #userPaginator="matPaginator"></mat-paginator>
</div>
